// Kontrastverhältnis nach WCAG 2.1.
//
// Bis E61 stand diese Rechnung nur in einer Testdatei
// (test/chipKontrast.test.tsx). Seit die Oberfläche selbst prüft, ob eine
// Zustandsfarbe als Schrift trägt (lib/zustandFarbe.ts), braucht sie die
// Rechnung zur Laufzeit — und der Test rechnet mit derselben Funktion,
// nicht mit einer Abschrift.

/** Relative Leuchtdichte einer Farbe in der Form `#RRGGBB`. */
export function leuchtdichte(hex: string): number {
  const h = hex.replace('#', '');
  const kanal = (i: number) => {
    const c = parseInt(h.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * kanal(0) + 0.7152 * kanal(2) + 0.0722 * kanal(4);
}

/** Kontrastverhältnis zweier Farben, 1 bis 21. */
export function kontrast(a: string, b: string): number {
  const [x, y] = [leuchtdichte(a), leuchtdichte(b)];
  return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
}
